<div class="container">
  <div class="main-card" >
    <div class="cards"  >
      <div class="card" style="margin-left: 15%;" >
        
        <a href="/home/posts"  (click)="closeNote()" style="margin-top: 15px;margin-left:15px; font-size: x-large;color: black;"><i class="fa-solid fa-xmark" ></i></a>
        <h5 style="text-align: center; margin-top: 0%;">edit your post
        </h5>
        <br>
        <form >
          <label style="margin-left: 10%; font-family:'poppins'; font-style:normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
        
          color: #4d4d4d;" for="title">Title</label>
          <input  style="width: 80%; margin-left: 10%;" class="form-control"  type="text" name="title" placeholder="Title" [(ngModel)]="opportunity.title" required #title="ngModel">
          <br>
          <label style="margin-left: 10%; font-family:'poppins'; font-style:normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
        
          color: #4d4d4d;" for="email">email</label>
          <input  style="width: 80%; margin-left: 10%;" class="form-control"  type="text" name="email" placeholder="email" [(ngModel)]="opportunity.email" required #email="ngModel">
          <br>
          <label style="margin-left: 10%; font-family:'poppins'; font-style:normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
        
          color: #4d4d4d;" for="numtlf">Phone Number</label>
          <input  style="width: 80%; margin-left: 10%;" class="form-control"  type="text" name="numtlf" placeholder="numtlf" [(ngModel)]="opportunity.numtlf" required #numtlf="ngModel">
          <br>
          
          <label style="margin-left: 10%; font-family:'poppins'; font-style:normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
        
          color: #4d4d4d;" for="description">description</label>
          <textarea style="width: 80%; margin-left: 10%;" class="form-control"  type="text" name="description" placeholder="Description" cols="30" rows="5" [(ngModel)]="opportunity.description" required #description="ngModel"></textarea>
          <br>
          <label style="margin-left: 10%; font-family:'poppins'; font-style:normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
        
          color: #4d4d4d;" for="image">Image</label>
          <input  style="width: 80%; margin-left: 10%;" class="form-control"  type="file" name="image" placeholder="image" accept="image/*" [(ngModel)]="opportunity.image" required #image="ngModel" (change)="onFileSelected($event)">
          <br>


         <!--<input  style="width: 80%; margin-left: 10%; margin-bottom: 15px;" class="form-control" type="file" name="image" (change)="onFileSelected($event)" accept=".jpeg, .png, .jpg" />--> 
          <button  class="btn btn-primary" style="margin-left: 45%;" (click)="update()" >Update</button>
           <!--<a routerLink="/home/posts" href="/home">
           <input [hidden]="hideimage" class="btn btn-primary" style="margin-left: 45%; margin-top: 15px;" type="submit" (click)="addImage()" value="Add Post" />
          </a>-->
          <div class="alert alert-success" [hidden]="showmsg" style=" width: 400px; margin-left: 28%; text-align: center; border-radius: 15px; margin-top: 40px;">
          {{ msg }}
          </div>
      
        </form>
      
      </div>
    </div>
  </div>
  

<!--
      <div class="row mt-5">
          
          <div class="col-3">
              <input [(ngModel)]="post.titre" type="text" class="form-control m-1" placeholder="Name of the project">
          </div>


          <div class="col-3">
              <input [(ngModel)]="post.description" type="text" class="form-control m-1" placeholder="Description of the project">
      </div>

      <div class="col -3">
          <input [(ngModel)]="post.email" type="text" class="form-control m-1" placeholder="Image url" disabled>
      </div>

      <div class="col-3">
          <input [(ngModel)]="post.numtlf" type="text" class="form-control m-1" placeholder="phone number">
      </div>

      <div class="col-3">
          <input [(ngModel)]="post.fb" type="text" class="form-control m-1" placeholder="FB link">
      </div>

      <div class="col-3">
          <input [(ngModel)]="post.insta" type="text" class="form-control m-1" placeholder="Insta link">
      </div>

      <div class="col-3">
          <input [(ngModel)]="post.tiktok" type="text" class="form-control m-1" placeholder="Linked Link">
      </div>
      <div class="col-3">
          <input [(ngModel)]="post.linked" type="text" class="form-control m-1" placeholder="Linked Link">
      </div>
      <div class="col-3">
          <input [(ngModel)]="post.ba9chich" type="text" class="form-control m-1" placeholder="Linked Link">
      </div>

      <div class="col-3">
          <button (click)="update()" class="btn form-control m-1">Update</button>
      </div>

      </div>
-->



